import React from 'react'
import Fold from '../home/Fold'
import Introduction from './Introduction'
import About from './About'
import Outro from './Outro'
import Footer from './Footer'

const KineAcuScene = () => {
    return (
        <>
            <Fold
                color="secondary-light"
                title="Acupunctuur, moxa, cupping & <span>acuspressuur</span> bij Helix."
                phone="+32 487 69 97 45"
                mail="gsuarez23@gmail.com"
                introduction="Guillem Suarze Salas is een kinesitherapeut en een erkend acupuncturist. Zijn passie voor genezing en welzijn maakt hem tot een toegewijde begeleider in jouw pad naar balans en herstel."
                appointment="tel:0487 69 97 45"
                imageVariant='fold-bg-image--accupuncture' />
            <Introduction />
            <About />
            <Outro />
            <Footer />
        </>
    )
}

export default KineAcuScene